<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("parts/delete", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "parts" });
        this.$notify({
          type: "success",
          message: this.$t('part.message.successdelete')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: "Error! The data could not be erased."
        });
      });
  }
};
</script>
<style>
</style>
